export default __webpack_public_path__ + "static/media/graph.4182c248.svg";